import * as React from 'react'

import Svg, { Path, Rect } from 'react-native-svg'

import { IconProps } from '../icons'

const WorkBag = ({ size = 36, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 36 36"
    fill="none"
    {...props}
  >
    <Rect x={0.5} y={0.5} width={35} height={35} rx={17.5} fill="#fff" />
    <Path
      d="M22.512 10.266v1.289c0 .36-.284.645-.645.645h-.644v-1.934a.638.638 0 0 0-.645-.645h-5.156a.638.638 0 0 0-.645.645V12.2h-.644a.638.638 0 0 1-.645-.645v-1.29a1.93 1.93 0 0 1 1.934-1.933h5.156a1.93 1.93 0 0 1 1.934 1.934Z"
      fill="#768DBB"
    />
    <Path
      d="M20.578 9.621H18V8.332h2.578a1.93 1.93 0 0 1 1.934 1.934v1.289c0 .36-.284.645-.645.645h-.644v-1.934a.638.638 0 0 0-.645-.645Z"
      fill="#2F4267"
    />
    <Path
      d="M29 11.555v14.18c0 1.07-.864 1.933-1.934 1.933H8.934A1.931 1.931 0 0 1 7 25.735v-14.18c0-.18.077-.335.193-.451l3.287 7.399h15.04l3.287-7.4c.116.117.193.271.193.452Z"
      fill="#B7C6DE"
    />
    <Path
      d="M29 11.555v14.18c0 1.07-.864 1.933-1.934 1.933H18v-9.165h7.52l3.287-7.4c.116.117.193.271.193.452Z"
      fill="#A7BBE0"
    />
    <Path
      d="m28.807 11.104-1.998 7.399a1.93 1.93 0 0 1-1.87 1.43H11.06a1.93 1.93 0 0 1-1.869-1.43l-1.998-7.4a.633.633 0 0 1 .451-.193h20.711c.18 0 .336.078.452.194Z"
      fill="#ECEFF5"
    />
    <Path
      d="m28.807 11.104-1.998 7.399a1.93 1.93 0 0 1-1.87 1.43H18V10.91h10.355c.18 0 .336.078.452.194Z"
      fill="#879CC2"
    />
    <Path
      d="M20.578 18h-5.156a.638.638 0 0 0-.645.645v2.578c0 .36.284.644.645.644h5.156a.638.638 0 0 0 .645-.644v-2.578a.638.638 0 0 0-.645-.645Z"
      fill="#768DBB"
    />
    <Path
      d="M21.223 18.645v2.578c0 .36-.284.644-.645.644H18V18h2.578c.361 0 .645.284.645.645Z"
      fill="#2F4267"
    />
    <Rect x={0.5} y={0.5} width={35} height={35} rx={17.5} stroke="#D1D9E9" />
  </Svg>
)

export default WorkBag
